module.exports = __webpack_public_path__ + "img/client7.f9bbb25b.svg";